export const uploadProgressErrorCode = {
    ABORTED: 'ABORTED',
    NETWORK_FAILED: 'NETWORK_FAILED',
    SERVER_ERROR: 'SERVER_ERROR',
} as const;

export type UploadProgressErrorCode =
    (typeof uploadProgressErrorCode)[keyof typeof uploadProgressErrorCode];

export interface UploadProgressErrorPayload {
    code: UploadProgressErrorCode;
    message?: string;
}
